import { useCallback } from "react";
import { Transaction } from "@common/types/transaction";
import { createTransactionsUrl } from "@components/transactions/lib/transactionsUrl";
import { useStateAwareNavigate } from "./useStateAwareNavigate";

export function useShowTransactionDetails<T extends Pick<Transaction, "id">>() {
    const navigate = useStateAwareNavigate();

    return useCallback(
        (transaction: T) => {
            const transactionUrl = createTransactionsUrl({
                transactionIds: [transaction.id],
            });

            navigate(transactionUrl);
        },
        [navigate],
    );
}
